import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, Box } from '@mui/material';

interface FaqViewModalProps {
  open: boolean;
  onClose: () => void;
  faq: { section: string; question: string; answer: string } | null;
}

const FaqViewModal: React.FC<FaqViewModalProps> = ({ open, onClose, faq }) => {
  if (!faq) return null;
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={false}
      sx={{
        '& .MuiDialog-paper': {
          width: 600,
          maxWidth: '95vw',
        }
      }}
    >
      <DialogTitle>
        <Typography variant="subtitle1" fontWeight={700} letterSpacing={.5}>FAQ Details</Typography>
      </DialogTitle>
      <DialogContent dividers>
        <Box sx={{ mb: 1.5 }}>
          <Typography variant="caption" color="text.secondary" fontWeight={600}>Section</Typography>
          <Typography variant="body2" fontWeight={700} sx={{ mb: 1 }}>{faq.section}</Typography>
        </Box>
        <Box sx={{ mb: 1.5 }}>
          <Typography variant="caption" color="text.secondary" fontWeight={600}>Question</Typography>
          <Typography variant="body2" fontWeight={700} sx={{ mb: 1 }}>{faq.question}</Typography>
        </Box>
        <Box>
          <Typography variant="caption" color="text.secondary" fontWeight={600}>Answer</Typography>
          <Typography variant="body2" fontWeight={500}>{faq.answer}</Typography>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="contained" color="primary" sx={{ fontWeight: 600, textTransform: 'none' }}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};

export default FaqViewModal;
